// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clearfix[data-v-7ba41cbc]::before, .clearfix[data-v-7ba41cbc]::after {\n  content: '';\n  width: 0;\n  height: 0;\n  clear: both;\n}\n.drawer_footer[data-v-7ba41cbc] {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
